module.exports = __webpack_public_path__ + "static/media/1.bc78ecfd.jpg";